// The kinds of investment offered on the Finances tab, and on a bill of type
// Investments (which the server links to an investment of this kind).
// Keep in step with INVESTMENT_TYPES in server/index.js.
export const INVESTMENT_TYPES = ["SIP / Mutual fund", "Stocks", "Fixed deposit", "Recurring deposit", "PPF", "NPS", "Gold", "Insurance", "Other"];
